// Static UI content for Jannesmann Baumaschinen website
// ---------------------------------------------------------
// NOTE: This file used to contain product/accessory data as well,
// but ALL product data has been migrated to MongoDB and is served
// via /api/products/*. The admin dashboard is the single source of
// truth for products.
//
// Only static UI strings (company info, marketing copy, hero images,
// and service descriptions) live here because they are not editable
// from the admin panel and do not change frequently.
// ---------------------------------------------------------

export const companyInfo = {
  name: "Jannesmann Baumaschinen",
  tagline: "Ihr Partner für Baumaschinen - Verkauf von hochwertigen Baggern",
  description: "Professionelle Baumaschinen für jeden Bedarf. Wir bieten qualitativ hochwertige Bagger zum Verkauf.",
  email: "info@jannesmann.de",
  phone: "02041 9877499",
  mobile: "0176 6430 2049",
  address: "Poststraße 6, 46236 Bottrop",
  logo: "https://customer-assets.emergentagent.com/job_99a08884-63b0-48b0-bdd8-26682827bf4f/artifacts/gcxwvbdn_E78C635A-AC78-4921-ABF3-777B2B6B34B1.PNG"
};

export const services = [
  {
    id: 1,
    title: "Verkauf von Baumaschinen",
    description: "Hochwertige Baumaschinen in verschiedenen Größen und Ausführungen. Vom Minibagger bis zum Kettenbagger - wir haben die richtige Maschine für Ihr Projekt.",
    icon: "ShoppingCart",
    features: [
      "Umfangreiche Auswahl an Neumaschinen",
      "Geprüfte Gebrauchtmaschinen",
      "Faire Preise und flexible Finanzierung",
      "Professionelle Beratung"
    ]
  },
  {
    id: 2,
    title: "Individuelle Beratung",
    description: "Persönliche Beratung für die Auswahl der perfekten Baumaschine. Wir helfen Ihnen, die richtige Entscheidung für Ihr Projekt zu treffen.",
    icon: "Users",
    features: [
      "Erfahrene Fachberater",
      "Detaillierte Produktinformationen",
      "Vorführungen möglich",
      "Langfristige Betreuung"
    ]
  },
  {
    id: 3,
    title: "Service & Support",
    description: "Umfassender Service rund um Ihre Baumaschine. Von der Beratung bis zur Übergabe - wir sind für Sie da.",
    icon: "Award",
    features: [
      "Kompetente Kaufberatung",
      "Transparente Preisgestaltung",
      "Professionelle Übergabe",
      "Nachbetreuung nach Kauf"
    ]
  }
];

export const heroImages = {
  main: "https://customer-assets.emergentagent.com/job_99a08884-63b0-48b0-bdd8-26682827bf4f/artifacts/phk872bj_IMG_3271.JPG",
  secondary: "https://images.unsplash.com/photo-1517089596392-fb9a9033e05b",
  banner: "https://customer-assets.emergentagent.com/job_99a08884-63b0-48b0-bdd8-26682827bf4f/artifacts/xl5cqpds_Banner.jpg",
  video: "https://customer-assets.emergentagent.com/job_99a08884-63b0-48b0-bdd8-26682827bf4f/artifacts/xy86mfbl_Bagger%20dreht.MOV",
  videoSchaufelKlein: "https://customer-assets.emergentagent.com/job_99a08884-63b0-48b0-bdd8-26682827bf4f/artifacts/yjafqv5d_schaufel%20klein.MOV",
  videoSchaufelGross: "https://customer-assets.emergentagent.com/job_99a08884-63b0-48b0-bdd8-26682827bf4f/artifacts/37d1vjxr_schaufel%20gro%C3%9F.MOV"
};

export const features = [
  {
    icon: "Award",
    title: "Qualität & Zuverlässigkeit",
    description: "Hochwertige Baumaschinen von führenden Herstellern"
  },
  {
    icon: "Wrench",
    title: "Service & Wartung",
    description: "Regelmäßig gewartete und einsatzbereite Maschinen"
  },
  {
    icon: "Clock",
    title: "Schnelle Verfügbarkeit",
    description: "Kurzfristige Bereitstellung für Ihr Projekt"
  },
  {
    icon: "HeadphonesIcon",
    title: "Persönliche Beratung",
    description: "Individuelle Beratung für Ihre Anforderungen"
  }
];

export const aboutUs = {
  title: "Über Jannesmann Baumaschinen",
  description: "Mit langjähriger Erfahrung im Bereich Baumaschinen sind wir Ihr zuverlässiger Partner für den Verkauf. Unser Fokus liegt auf qualitativ hochwertigen Baggern - vom kompakten Minibagger bis zum leistungsstarken Kettenbagger.",
  values: [
    "Qualität und Zuverlässigkeit",
    "Kundenorientierung",
    "Faire Preise",
    "Professioneller Service"
  ]
};
